import React, { useEffect, useState } from 'react';
import { Container, Paper, Tab, Tabs, Grid } from '@material-ui/core';
import { Switch, Link, useHistory } from 'react-router-dom';
import useAsiteRelaticsRoutes from '../hooks/useAsiteRelaticsRoutes';
import useStyles from '../../../styles/useStyles';
import useStylesPaper from '../../../styles/paper.styles';
import { useSettings } from '../hooks/useSettings';
import RelaticsSyncLogs from './RelaticsSyncLogs/RelaticsSyncLogs';
import useSecurity from './../hooks/useSecurity/useSecurity'
import { LoadingPanel } from '../../../ui';
import { SabsPrivateRoute } from '../../../components/PrivateRoute';
import { ESyncLogsTabs } from '../types';
import { useSignalr } from '../../asite-relatics/hooks/useSignalr';
const Menu = () => {
    const classes = useStyles();
    const history = useHistory();
    const classesPaper = useStylesPaper();
    const { routes, path } = useAsiteRelaticsRoutes();
    const { changeTab, currentTab } = useSettings();
    const [tabsValue, setTabsValue] = useState('relatics');
    const { isPageAuthorized, isLoaded } = useSecurity();
    const accessDeniedPath = '/access-denied';

    const {connection} = useSignalr('/fastdraft-relatics-sync-events');

    useEffect(() => {
        if(isLoaded) {
            if (!currentTab) {
                history.push(path + '/logs'); 
            }
            else {
                setTabsValue(currentTab);
            }
        }
        console.log('currentTab', currentTab);
        console.log('isLoaded', isLoaded);
        

    }, [currentTab, setTabsValue, isLoaded]); 

    return (
        <Container maxWidth="xl">
             {isLoaded && <Grid container spacing={3} justify="center">
             <Grid item md={12}>
                    <Paper className={classesPaper.root} style={{ height: '56px' }}>
                        <Tabs
                            className={classes.tab}
                            value={tabsValue}
                            indicatorColor="primary"
                            textColor="primary"
                            centered>
                            <Tab
                                className={classes.tabItem}
                                label="Relatics sync logs"
                                value={'logs'}
                                component={Link}
                                to={routes['logs']}
                                onClick={() => changeTab(ESyncLogsTabs.logs)}
                            />
                        </Tabs>
                    </Paper>
                </Grid>
                <Grid item md={12}>
                    <Paper className={classesPaper.defaultPaper}>
                        <Switch>
                            <SabsPrivateRoute
                                path={routes['logs']}
                                redirectTo={accessDeniedPath}
                                authorize={isPageAuthorized}
                            >
                                <RelaticsSyncLogs connection={connection} />
                            </SabsPrivateRoute>
                        </Switch>
                    </Paper>
                </Grid> 
                
            </Grid>
        }
        {!isLoaded && <LoadingPanel />}
        </Container>
    );
};

export default Menu;
